import React, { createContext, useContext, useMemo } from 'react';
import useUserSettings from '../hooks/useUserSettings';
import { DEFAULT_FORMATTING_SETTINGS, FormattingSettings } from '../utils/formatting';

type FormattingContextValue = FormattingSettings;

const FormattingContext = createContext<FormattingContextValue>(DEFAULT_FORMATTING_SETTINGS);

export const FormattingProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { settings } = useUserSettings();
  const browserTimeZone = (() => {
    try {
      return Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC';
    } catch {
      return 'UTC';
    }
  })();

  const value = useMemo<FormattingContextValue>(
    () => ({
      locale: settings?.formatting?.locale || DEFAULT_FORMATTING_SETTINGS.locale,
      currency: settings?.formatting?.currency || DEFAULT_FORMATTING_SETTINGS.currency,
      timeZone: settings?.formatting?.timezone || browserTimeZone || 'UTC',
    }),
    [browserTimeZone, settings?.formatting?.currency, settings?.formatting?.locale, settings?.formatting?.timezone]
  );

  return <FormattingContext.Provider value={value}>{children}</FormattingContext.Provider>;
};

export const useFormatting = (): FormattingContextValue => useContext(FormattingContext);

export default FormattingContext;
